/**
 * Joins one or more "why buys are blocked" reasons into the message we show in
 * disabled-button tooltips and the inline banner. Kept tiny on purpose — the
 * point is that the two surfaces never drift.
 */
export function composeBuyDisabledMessage(reasons: Array<string | null | undefined>): string | null {
  const filtered = reasons.filter((r): r is string => typeof r === 'string' && r.length > 0)
  if (filtered.length === 0) return null
  return `${filtered.join(' · ')}. Buys disabled — closes still allowed.`
}
